import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../services/adminService';
import { Shield, CheckCircle } from 'lucide-react';

const formatBilling = (plan) => {
  if (plan.billing_type === 'one_time') return `${plan.duration_months} months · one-time`;
  return `Auto-renew every ${plan.billing_interval_months} month(s)`;
};

const Offers = () => {
  const { data: plans = [], isLoading } = useQuery({
    queryKey: ['membershipPlansPublic'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('membership_plans')
        .select('*')
        .eq('is_active', true)
        .order('position', { ascending: false });
      if (error) throw error;
      return data || [];
    },
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">RSA Membership Plans</h1>
        <p className="text-gray-600 mt-1">Roadside assistance subscriptions — visible from admin-managed plans</p>
      </div>

      {isLoading ? (
        <p className="text-gray-500">Loading plans…</p>
      ) : plans.length === 0 ? (
        <p className="text-gray-500">No plans yet. Admin → Settings → RSA Membership Plans</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {plans.map((plan) => (
            <div key={plan.id} className={`bg-white rounded-xl border p-6 shadow-sm ${plan.is_popular ? 'border-red-400 border-2' : 'border-gray-200'}`}>
              <div className="flex items-center gap-2 mb-2">
                <Shield className="text-primary-600" size={22} />
                <h2 className="text-xl font-bold">{plan.name}</h2>
                {plan.is_popular && <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded">Popular</span>}
              </div>
              {plan.short_description && <p className="text-gray-600 text-sm">{plan.short_description}</p>}
              <p className="text-3xl font-bold text-primary-700 mt-4">₹{Number(plan.price).toLocaleString('en-IN')}</p>
              <p className="text-xs text-gray-500 mt-1">{formatBilling(plan)}</p>
              <ul className="mt-4 space-y-2">
                {(plan.benefits || []).map((b, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                    <CheckCircle size={16} className="text-green-600 mt-0.5 shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Offers;
